export default class Result {

    /** For debugging purposes */
    public resultType: string = "Result";

    public cashWon: number = 0;

    public linkedResult: Result;

    public getPriority() {
        return 50;
    }
}
